import { render, staticRenderFns } from "./VNotification.vue?vue&type=template&id=3a4486fc&scoped=true&"
import script from "./VNotification.vue?vue&type=script&lang=ts&"
export * from "./VNotification.vue?vue&type=script&lang=ts&"
import style0 from "./VNotification.vue?vue&type=style&index=0&id=3a4486fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4486fc",
  null
  
)

export default component.exports